<style lang="less">
    @import "../../../styles/radioAndCheckbox.less";
</style>
<template>
    <div id="copyrightRegistration">
        <div style="height: 20px;"></div>
        <div class="copyrightRegistration">
            <Row class-name="row_item">
                <Col class="col_label"><p>权利权属：</p></Col>
                <Col class="col_value">
                    <RadioGroup class="radio_group monitor_type"
                                v-model="form.copyrightType"
                                @on-change="powerChange">
                        <Radio v-for="(item,index) in powers" class="radio_item" :label="item.value">
                            <span class="radio_item_name">{{ item.label }}</span></Radio>
                    </RadioGroup>
                </Col>
            </Row>
            <hr style="height:1px;border:none;border-top:1px solid #CBCBCB;"/>
            <Row style="height: auto;min-height: 80px;">
                <Col class="col_label"></Col>
                <Col class="col_value">
                    <p class="power_des" style="margin-top: 1px; margin-bottom: 1px;">*{{powers_des}}</p>
                </Col>
            </Row>
            <hr style="height:1px;border:none;border-top:1px solid #CBCBCB;"/>

            <Row class-name="row_item" style="height: auto;min-height: 80px;">
              <Col class="col_label"><p>权利权属方式：</p></Col>
              <Col class="col_value">
                <RadioGroup class="radio_group monitor_type"
                            v-model="form.powerBy">
                  <Radio v-for="(item,index) in powerBys" class="radio_item" :label="item.value">
                    <span class="radio_item_name">{{ item.label }}</span></Radio>
                </RadioGroup>
              </Col>
            </Row>
            <hr style="height:1px;border:none;border-top:1px solid #CBCBCB;"/>

          <Row class-name="row_item" style="height: auto;min-height: 80px;">
            <Col class="col_label"><p>作者：</p></Col>
            <Col class="col_value" style="flex-wrap: wrap;">
              <!-- ✅ 按照 autors 数组顺序显示（即选择顺序） -->
              <div v-for="(item,index) in autors" :key="index" class="show_Picture_autor">
                <div class="showSc_autor" disabled="true">
                  <p class="autors_class" disabled="true">{{item.name}}</p>
                  <img @click.stop="deleteAutor(item)" class="showshanchu"
                       src="@/assets/regist/autor_delete.png" alt='版权登记'/>
                </div>
              </div>
              <p class="form_input_btn_select" @click="addAutor('autor')">选择作者</p>
            </Col>
          </Row>

          <hr style="height:1px;border:none;border-top:1px solid #CBCBCB;"/>

          <!-- 著作权人区域 -->
          <Row class-name="row_item" style="height: auto;min-height: 80px;">
            <Col class="col_label"><p>著作权人：</p></Col>
            <Col class="col_value" style="flex-wrap: wrap;">
              <!-- ✅ 按照 obligees 数组顺序显示（即选择顺序） -->
              <div v-for="(item,index) in obligees" :key="index" class="show_Picture_autor">
                <div class="showSc_autor" disabled="true">
                  <p class="autors_class" disabled="true">{{item.name}}</p>
                  <img @click.stop="deleteObligee(item)" class="showshanchu"
                       src="@/assets/regist/autor_delete.png" alt='版权登记'/>
                </div>
              </div>
              <p class="form_input_btn_select" @click="addAutor('obligee')">选择权利人</p>
            </Col>
          </Row>
          <hr style="height:1px;border:none;border-top:1px solid #CBCBCB;"/>
          <Row class-name="row_item" style="width: 55%;height: 80px;">
            <Col class="col_label"><p>署名：</p></Col>
            <Col class="col_value">
              <input placeholder="请输入署名(非必填)" v-model.trim="form.signature" @input="signatureChange" class="form_input_1" maxlength="18"/>
              <span style="margin-left: 10px">{{signatureLength}}</span><span>/</span><span>18</span>
            </Col>
          </Row>
            <hr style="height:1px;border:none;border-top:1px solid #CBCBCB;"/>
            <Row class-name="row_item">
                <Col class="col_label"><p>作品类型：</p></Col>
                <Col class="col_value">
                    <Select ref="worksType" :clearable="true" v-model="form.workType" placeholder="请选择作品类型"
                            class="selectWidth" @on-change="workTypeChange">
                        <Option v-for="(item, index) in workTypes" :value="item.code" :key="index">{{item.name}}
                        </Option>
                    </Select>
                </Col>
            </Row>
            <hr style="height:1px;border:none;border-top:1px solid #CBCBCB;"/>
            <Row class-name="row_item" style="width: 55%;height: 120px;">
                <Col class="col_label"><p>作品名称：</p></Col>
                <Col class="col_value">
                  <input placeholder="请输入作品名称" v-model.trim="form.workFullname" @input="workFullnameChange" class="form_input_1" maxlength="60"/>
                  <span style="margin-left: 10px">{{workFullNameLength}}</span><span>/</span><span>60</span>
                </Col>
<!--              <div class="showtextDf" style="display: flex;margin-left: 200px;margin-top: -27px">
                <p style="display: flex;"><img src="../../../assets/common/tishi.png" height="18" width="18"/>作品名称请控制在60个字符（30个汉字）以内。</p>
              </div>-->
            </Row>
            <hr style="height:1px;border:none;border-top:1px solid #CBCBCB;"/>
            <Row class-name="row_item_1" :style="{'height':worksList.length>0?'310px':'226px'}">
                <Col class="col_label top20"><p>作品文件：</p></Col>
                <Col class="col_value">
                    <div class="certList_right">
                        <div class="certList_right_top">
                            <MyUploadHw :index="1" ref="workFile" :oldShowList="worksList" :fileMultiue="true"
                                        textContent="添加作品样本"
                                        @click.native="toClick"
                                        :maxNumber="maxNumber"
                                        :accept="otherFileFormat"
                                        :pictureTypes="20971520" :documnetTypes="104857600" :videoAndMusics="104857600" :otherTypes="104857600"
                                        :maxSizes="102400"
                                        :reSubmitDisabled="isReset"
                                        @listentochildevent="showmessagefromchild"/>
                            <div class="showtextDf">
                                <div>温馨提示：</div>
                                <p>1、文件数量6个以内；</p>
                                <p>2、上传文件大小100M以内(图片类20M以内)；</p>
                                <!-- <p v-if="this.workType_fileAccept !='' && this.workType_fileAccept !='*'">
                                    3、上传{{this.workType_fileAccept}}格式的文件</p> -->

                            </div>
                        </div>
                        <div style="display:flex;justify-content:flex-start;">
                            <div v-for="(item,index) in worksList" :key="index" class="show_Picture">
                                <div class="showSc upload_progress" v-if="item.status && item.status == 'uploading' ">
                                    <p class="upload_progress_desc">{{ item.uploadProgress }}%</p>
                                    <p>上传中</p>

                                    <div :style="{height:item.uploadProgress + '%'}"
                                         class="upload_progress_shadow"></div>
                                </div>

                                <div v-else class="showSc">
                                    <!--                                    <img @onload="handleImageLoaded(item)" style="width:103px;height:70px;" :src="item.url" alt="图片过大" />-->
                                    <img @onload="handleImageLoaded(item)" style="width:103px;height:70px;"
                                         :src="item.url" alt="图片过大"/>
                                    <!--                                    <progressive-img  :src="[item.isIcon?item.url:default_icon]" alt="" @click="workDownLoad(item)"-->
                                    <!--                                                      style="cursor: pointer;width: 103px;height: 70px;" />-->
                                    <span class="showDelete"><img @click.stop="deleteList(item)" class="showshanchu"
                                                                  src="@/assets/common/shanchu.png" alt='版权登记'/></span>
                                </div>

                                <Tooltip max-width="300" placement="bottom"
                                         :content="item.name ? item.name.split('.')?item.name.split('.')[0]:item.name:''">
                                    <div style="line-height: 1">{{item.name ?
                                        item.name.split('.')?item.name.split('.')[0]:item.name:''}}
                                    </div>
                                </Tooltip>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>

          <hr style="height:1px;border:none;border-top:1px solid #CBCBCB;"/>
          <Row class-name="row_item_1" :style="{'height':productImageUploadFileList.length>0?'auto':'288px',paddingBottom:'24px',boxSizing:'border-box'}">
            <Col class="col_label top20"><p>作品展示图：</p></Col>
            <Col class="col_value">
              <div class="certList_right">
                <div class="certList_right_top">
                  <MyUploadHw :index="2" ref="productImageUploadFile" :oldShowList="productImageUploadFileList"
                              checkFormat="check"
                              :fileMultiue="false"
                              accept=".jpg,.png,.jpeg" textContent="选择文件"
                              :maxNumber="1" :pictureTypes="26214400" :documnetTypes="26214400" :otherTypes="26214400" :maxSizes="25600"
                              @listentochildevent="showmessagefromchild4"/>
                  <div class="showtextDf">
                    <div>温馨提示：</div>
                    <p :style="{'font-size': '14px', 'font-weight': '400', 'color': '#999999', 'line-height': '20px'}">1、作品展示图将显示到证书的“作品展示页”；</p>
                    <p :style="{'font-size': '14px', 'font-weight': '400', 'color': '#999999', 'line-height': '20px'}">2、上传的作品展示图须是登记作品文件内的内容，否则此作品登记申请将被驳回；</p>
                    <p :style="{'font-size': '14px', 'font-weight': '400', 'color': '#999999', 'line-height': '20px'}">3、支持上传1张图片，图片大小不超过5M，支持png|jpg|jpeg格式；</p>
                    <p :style="{'font-size': '14px', 'font-weight': '400', 'color': '#999999', 'line-height': '20px'}">4、请勿上传CMYK色彩模式的图片。</p>
                  </div>
                </div>
                <div class="atlas_group">
                  <div v-for="(item,index) in productImageUploadFileList" :key="index" class="show_Picture">

                    <div class="showSc upload_progress" v-if="item.status && item.status == 'uploading' ">
                      <p class="upload_progress_desc">{{ item.uploadProgress }}%</p>
                      <p>上传中</p>

                      <div :style="{height:item.uploadProgress + '%'}"
                           class="upload_progress_shadow"></div>
                    </div>

                    <div v-else class="showSc">
                      <img @onload="handleImageLoaded(item)" style="width:103px;height:70px;"
                           :src="item.url" alt='版权登记'/>
                      <span class="showDelete"><img @click.stop="deleteList_zst(item)" class="showshanchu"
                                                    src="@/assets/common/shanchu.png" alt='版权登记'/></span>
                    </div>
                    <Tooltip max-width="300" placement="bottom"
                             :content="item.name ? item.name.split('.')?item.name.split('.')[0]:item.name:''">
                      <div style="line-height: 1">{{item.name ?
                          item.name.split('.')?item.name.split('.')[0]:item.name:''}}
                      </div>
                    </Tooltip>
                  </div>
                </div>
              </div>
            </Col>
          </Row>

<!--          <hr style="height:1px;border:none;border-top:1px solid #CBCBCB;"/>
          <Row class-name="row_item_1" :style="{'height':displayImageList.length>0?'310px':'226px'}">
            <Col class="col_label top20"><p>作品展示图：</p></Col>
            <Col class="col_value">
              <div class="certList_right">
                <div class="certList_right_top">
                  <MyUploadHw :index="1" ref="displayImageFile" :oldShowList="displayImageList" :fileMultiue="true"
                              textContent="添加展示图样本"
                              :maxNumber="displayImageMaxNumber"
                              :accept="displayImageFormat"
                              :pictureTypes="20971520" :documnetTypes="104857600" :videoAndMusics="104857600" :otherTypes="104857600"
                              :maxSizes="102400"
                              @listentochildevent="showmessagefromchildDisplayImage"/>
                  <div class="showtextDf">
                    <div>温馨提示：</div>
                    <p>1、如作品类型为美术或摄影作品，则自动生成“作品展示页”；</p>
                    <p>2、如作品类型为非美术、摄影作品，需上传展示页图片，若您未上传则无“作品展示页”；</p>
                    <p>（非必填）</p>
                  </div>
                </div>
                <div style="display:flex;justify-content:flex-start;">
                  <div v-for="(item,index) in displayImageList" :key="index" class="show_Picture">
                    <div class="showSc upload_progress" v-if="item.status && item.status == 'uploading' ">
                      <p class="upload_progress_desc">{{ item.uploadProgress }}%</p>
                      <p>上传中</p>

                      <div :style="{height:item.uploadProgress + '%'}"
                           class="upload_progress_shadow"></div>
                    </div>

                    <div v-else class="showSc">
                      &lt;!&ndash;                                    <img @onload="handleImageLoaded(item)" style="width:103px;height:70px;" :src="item.url" alt="图片过大" />&ndash;&gt;
                      <img @onload="handleImageLoaded(item)" style="width:103px;height:70px;"
                           :src="item.url" alt="图片过大"/>
                      &lt;!&ndash;                                    <progressive-img  :src="[item.isIcon?item.url:default_icon]" alt="" @click="workDownLoad(item)"&ndash;&gt;
                      &lt;!&ndash;                                                      style="cursor: pointer;width: 103px;height: 70px;" />&ndash;&gt;
                      <span class="showDelete"><img @click.stop="deleteList(item)" class="showshanchu"
                                                    src="@/assets/common/shanchu.png" alt='版权登记'/></span>
                    </div>

                    <Tooltip max-width="300" placement="bottom"
                             :content="item.name ? item.name.split('.')?item.name.split('.')[0]:item.name:''">
                      <div style="line-height: 1">{{item.name ?
                          item.name.split('.')?item.name.split('.')[0]:item.name:''}}
                      </div>
                    </Tooltip>
                  </div>
                </div>
              </div>
            </Col>
          </Row>-->

            <hr style="height:1px;border:none;border-top:1px solid #CBCBCB;"/>
            <Row class-name="row_item">
                <Col class="col_label"><p>作品创作性质：</p></Col>
                <Col class="col_value">
                    <Select v-model="form.creativeType" placeholder="请选择作品创作性质" class="selectWidth">
                        <Option v-for="(option, index) in creativeTypes" :value="option.value" :key="index">
                            {{option.label}}
                        </Option>
                    </Select>
                </Col>
            </Row>
            <hr style="height:1px;border:none;border-top:1px solid #CBCBCB;"/>
            <Row class-name="row_item">
                <Col class="col_label"><p>创作完成时间：</p></Col>
                <Col class="col_value">
                    <DatePicker type="date" v-model="form.completeDateEnd" :options="options_create"
                                @on-change = "changeCompleteDateEnd"
                                :value="form.completeDateEnd" placeholder="选择日期"
                                class="datePickerClass selectWidth"></DatePicker>
                </Col>
            </Row>
            <hr style="height:1px;border:none;border-top:1px solid #CBCBCB;"/>
            <Row class-name="row_item">
                <Col class="col_label"><p>作品完成地点：</p></Col>
                <Col class="col_value">
                    <el-cascader
                            v-model="placeOfCompletion"
                            :options="citys"
                            @change="placeOfCompletionChange"
                            class="selectWidth"></el-cascader>
                    <input v-if="placeOfCompletion[0]=='其他'" v-model.trim="form.completeCity" placeholder="请输入作品完成地点"
                           class="form_input_1" style="width: 180px;margin-left: 15px;" maxlength="50"/>
                </Col>
            </Row>
            <hr style="height:1px;border:none;border-top:1px solid #CBCBCB;"/>
            <Row class-name="row_item">
                <Col class="col_label"><p>作品发表状态：</p></Col>
                <Col class="col_value">
                    <div style="display: flex;">
                        <Select v-model="form.publishStatus" placeholder="请选择发表状态" style="width: 160px">
                            <Option v-for="(option, index) in publishStatusArr" :value="option.value" :key="index">
                                {{option.label}}
                            </Option>
                        </Select>
                        <div v-if="form.publishStatus == '1'" class="publish_status">
                            <span class="pulish_status_span">作品发表时间</span>
                            <DatePicker type="date" v-model="form.publishDate" :options="options_publish"
                                        placeholder="选择日期" class="datePickerClass" style="width: 140px;"></DatePicker>
                            <span class="pulish_status_span">作品发表地点</span>
                            <!--                            <Cascader v-model="form.publishCity"  :props="{ value: 'label' }" :data="citys"></Cascader>-->
                            <el-cascader v-model="placeOfPublication"
                                         :props="{ value: 'label' }"
                                         @change="placeOfPublicationChange"
                                         :options="citys"></el-cascader>
                            <input v-if="placeOfPublication[0]=='其他'" v-model.trim="form.publishCity"
                                   placeholder="请输入作品发表地点" class="form_input_1"
                                   style="width: 180px;margin-left: 15px;" maxlength="50"/>
                        </div>
                    </div>
                </Col>
            </Row>
          <Row class-name="row_item_1" :style="{'height':form.publishStatus == '1'?'auto':'1px','paddingBottom':form.publishStatus == '1'?'24px':'0px',boxSizing:'border-box', marginLeft: '40px'}">
            <div v-if="form.publishStatus == '1'" class="publish_status">
              <span class="pulish_status_span">已发表的截图或照片</span>
              <div class="certList_right">
                <div class="certList_right_top">
                  <MyUploadHw :index="3" ref="publishUrlFile" :oldShowList="publishUrlList" :fileMultiue="false"
                              accept=".jpg,.jpeg,.png,.pdf,.doc,.docx" textContent="选择文件"
                              :maxNumber="99999" :pictureTypes="10485760" :documnetTypes="10485760" :otherTypes="10485760" :maxSizes="10240"
                              @listentochildevent="showmessagefromchild3"/>
                  <div class="showtextDf">
                    <div>温馨提示：</div>
                    <p>请保证发表截图中的日期与所填首次发表日期一致；</p>
                    <p>只支持jpg、jpeg、png、pdf、doc、docx，大小10M以内；</p>
                    <p>若有多个发表截图，可拼接成长图，或保存至PDF、Word文档中上传。</p>
                    <p>（必填）</p>
                  </div>
                </div>
                <div class="atlas_group">
                  <div v-for="(item,index) in publishUrlList" :key="index" class="show_Picture">

                    <div class="showSc upload_progress" v-if="item.status && item.status == 'uploading' ">
                      <p class="upload_progress_desc">{{ item.uploadProgress }}%</p>
                      <p>上传中</p>

                      <div :style="{height:item.uploadProgress + '%'}"
                           class="upload_progress_shadow"></div>
                    </div>

                    <div v-else class="showSc">
                      <img @onload="handleImageLoaded(item)" style="width:103px;height:70px;"
                           :src="item.url" alt='版权登记'/>
                      <span class="showDelete"><img @click.stop="deleteList_fj2(item)" class="showshanchu"
                                                    src="@/assets/common/shanchu.png" alt='版权登记'/></span>
                    </div>
                    <Tooltip max-width="300" placement="bottom"
                             :content="item.name ? item.name.split('.')?item.name.split('.')[0]:item.name:''">
                      <div style="line-height: 1">{{item.name ?
                          item.name.split('.')?item.name.split('.')[0]:item.name:''}}
                      </div>
                    </Tooltip>
                  </div>
                </div>
              </div>
            </div>
          </Row>

          <hr style="height:1px;border:none;border-top:1px solid #CBCBCB;"/>
          <Row class-name="row_item_1" :style="{'height':autGuarAnnexUploadFileList.length>0?'auto':'288px',paddingBottom:'24px',boxSizing:'border-box'}">
            <Col class="col_label top20"><p>权利保证书：</p></Col>
            <Col class="col_value">
              <div class="certList_right">
                <div class="certList_right_top">
                  <MyUploadHw :index="4" ref="autGuarAnnexUploadFile" :oldShowList="autGuarAnnexUploadFileList" :fileMultiue="false"
                              accept=".jpg,.png,.pdf,.doc,.docx,.xlsx" textContent="选择文件"
                              :maxNumber="1" :pictureTypes="26214400" :documnetTypes="26214400" :otherTypes="26214400" :maxSizes="25600"
                              @listentochildevent="showmessagefromchild5"/>
                  <div class="showtextDf">
                    <div>温馨提示：</div>

                    <span :style="{'font-size': '14px', 'font-weight': '400', 'color': '#999999', 'line-height': '20px'}">
                                  请将作品权利保证书下载后，打印并签字盖章，在此处上传，务必确保《权利保证书》中的作品名称与申请人及签字公章与所填信息一致。
                                </span>
                    <a :href=[guaranteeTemplet[0]] target='_blank' download='' className="creatInfo-span"
                       :style="{'color': '#FFBB19', 'marginLeft': '10px', 'display': 'inline-block', 'text-decoration': 'underline'}">下载模板</a>
                    <p>（必填）</p>
                  </div>
                </div>
                <div class="atlas_group">
                  <div v-for="(item,index) in autGuarAnnexUploadFileList" :key="index" class="show_Picture">

                    <div class="showSc upload_progress" v-if="item.status && item.status == 'uploading' ">
                      <p class="upload_progress_desc">{{ item.uploadProgress }}%</p>
                      <p>上传中</p>

                      <div :style="{height:item.uploadProgress + '%'}"
                           class="upload_progress_shadow"></div>
                    </div>

                    <div v-else class="showSc">
                      <img @onload="handleImageLoaded(item)" style="width:103px;height:70px;"
                           :src="item.url" alt='版权登记'/>
                      <span class="showDelete"><img @click.stop="deleteList_bzs(item)" class="showshanchu"
                                                    src="@/assets/common/shanchu.png" alt='版权登记'/></span>
                    </div>
                    <Tooltip max-width="300" placement="bottom"
                             :content="item.name ? item.name.split('.')?item.name.split('.')[0]:item.name:''">
                      <div style="line-height: 1">{{item.name ?
                          item.name.split('.')?item.name.split('.')[0]:item.name:''}}
                      </div>
                    </Tooltip>
                  </div>
                </div>
              </div>
            </Col>
          </Row>


            <hr style="height:1px;border:none;border-top:1px solid #CBCBCB;"/>
            <Row class-name="row_item_1" :style="{'height':enclosureList.length>0?'auto':'288px',paddingBottom:'24px',boxSizing:'border-box'}">
                <Col class="col_label top20"><p>作品相关权属文件：</p></Col>
                <Col class="col_value">
                    <div class="certList_right">
                        <div class="certList_right_top">
                            <MyUploadHw :index="5" ref="encolosureFile" :oldShowList="enclosureList" :fileMultiue="true"
                                        accept=".jpg,.png,.pdf,.doc,.docx,.xlsx" textContent="选择文件"
                                        :maxNumber="5" :pictureTypes="26214400" :documnetTypes="26214400" :otherTypes="26214400" :maxSizes="25600"
                                        @listentochildevent="showmessagefromchild1"/>
                            <div class="showtextDf">
                                <div>温馨提示：</div>

                                <p>1、请将与作品权属相关的文件（例如签署的协议，合同等）上传在此处；</p>
                                <span :style="{'font-size': '14px', 'font-weight': '400', 'color': '#999999', 'line-height': '20px'}">
                                  2、未成年（未满18周岁）权利人提交作品需要同时提供《监护人承诺保证书》及监护人身份证正反面；
                                </span>
                                <a :href=[guaranteeTemplet[1]] target='_blank' download='' className="creatInfo-span"
                                 :style="{'color': '#FFBB19', 'marginLeft': '10px', 'display': 'inline-block', 'text-decoration': 'underline'}">下载模板</a>
                                <p>3、最多只能上传5个文档，文档总大小25M以内，只支持jpg、png、pdf、doc、docx、xlsx格式；</p>
                                <p>（此处为附件上传，请不要将作品文件传在此处）</p>
                            </div>
                        </div>
                        <div class="atlas_group">
                            <div v-for="(item,index) in enclosureList" :key="index" class="show_Picture">

                                <div class="showSc upload_progress" v-if="item.status && item.status == 'uploading' ">
                                    <p class="upload_progress_desc">{{ item.uploadProgress }}%</p>
                                    <p>上传中</p>

                                    <div :style="{height:item.uploadProgress + '%'}"
                                         class="upload_progress_shadow"></div>
                                </div>

                                <div v-else class="showSc">
                                    <img @onload="handleImageLoaded(item)" style="width:103px;height:70px;"
                                         :src="item.url" alt='版权登记'/>
                                    <span class="showDelete"><img @click.stop="deleteList_fj(item)" class="showshanchu"
                                                                  src="@/assets/common/shanchu.png" alt='版权登记'/></span>
                                </div>
                                <Tooltip max-width="300" placement="bottom"
                                         :content="item.name ? item.name.split('.')?item.name.split('.')[0]:item.name:''">
                                    <div style="line-height: 1">{{item.name ?
                                        item.name.split('.')?item.name.split('.')[0]:item.name:''}}
                                    </div>
                                </Tooltip>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>

            <hr style="height:1px;border:none;border-top:1px solid #CBCBCB;"/>
            <Row class-name="row_item_1" style="min-height: 130px;"
                 v-show="form.copyrightType=='2' || form.copyrightType=='4' || form.copyrightType=='5'">
                <Col class="col_label top20"><p>创作声明：</p></Col>
                <Col class="col_value top20">
                    <slot>
                        <div>
                            <div style="display: flex;align-items: center;">
                                <MyUploadHw
                                        v-show="statementList.length == 0 ?
                                         true :
                                         statementList[0].status ?
                                         statementList[0].status == 'uploading' ?
                                         false :
                                         true :
                                         true "
                                        :index="6"
                                        ref="stateFile"
                                        :oldShowList="statementList"
                                        :fileMultiue="false"
                                        accept=".jpg,.png"
                                        :pictureTypes="10485760"
                                        styleType="btn"
                                        @listentochildevent="showmessagefromchild2"/>

                                <div class="upload_progress_one" v-if="statementList.length == 0 ?
                                         false :
                                         statementList[0].status ?
                                         statementList[0].status == 'uploading' ?
                                         true :
                                         false :
                                         false ">
                                    上传中 {{ statementList[0].uploadProgress }}%

                                    <div :style="{width:statementList[0].uploadProgress + '%'}"
                                         class="upload_progress_one_shadow"></div>
                                </div>

                                <!--                                <Tooltip max-width="400"  v-if="declare_upload_success" placement="top" :content="declare_file_name">-->
                                <!--                                    <span class="declare_upload_success_name">{{ declare_file_name }}</span>-->
                                <!--                                </Tooltip>-->
                                <span style="margin-left: 20px;">{{declare_file_name}}</span>
                                <a :href="[declare_down_urls[form.copyrightType]]" target='_blank' download='合作声明.docx'
                                   class="creatInfo-span">下载模板</a>
                                <span>｜</span>
                                <u class="declare_sample" @click="showDeclareSample">查看样例</u>
                            </div>
                            <div className="tipUpload">
                            </div>
                            <p>温馨提示：请按照模板样例内容仔细填写，注意个人需手写签字，企业需加盖公章，填写完成后拍照上传。格式jpg,png，大小10M以内。</p>
                            <p style="padding-left: 70px;margin-top: 10px;">重新上传，会覆盖原来的文件。</p>
                        </div>
                    </slot>
                </Col>
            </Row>

            <hr v-if="form.copyrightType=='2' || form.copyrightType=='4' || form.copyrightType=='5'"
                style="height:1px;border:none;border-top:1px solid #CBCBCB;"/>
            <Row class-name="row_item_1" style="min-height: 282px;">
                <Col class="col_label top20"><p>权益拥有情况：</p></Col>
                <Col class="col_value top20" style="width: 1155px;">
                    <div style="width: 100%;">
                        <div @click="isSlectedAll = !isSlectedAll">
                            <!--                            <img :src="[isSlectedAll?checkedIcon:unCheckedIcon]" class="checkImg">-->
                            <span :class="'checkImg' + [isSlectedAll ? ' active' : '']"></span>
                            <span>全选</span>
                        </div>
<!--                        <hr style="height:1px;border:none;border-top:1px solid #CBCBCB;margin-top: 10px;"/>-->
                        <div class="owner_checkbox">
                            <div v-for="(item,index) in Ownership" :key="index" :class="[item.checked?'active':'']"
                                 @click="item.checked = !item.checked">
                                <!--                                <input type="checkbox" v-model="item.checked"/><span>{{item.label}}</span>-->
                                <p> {{item.label}}</p>
                                <img src="@/assets/regist/reg_xz.png" alt='版权登记' v-show="item.checked">
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>

            <hr style="height:1px;border:none;border-top:1px solid #CBCBCB;"/>
            <Row class-name="row_item_1" style="min-height: 202px;">
                <Col class="col_label top20"><p>创作意图：</p></Col>
                <Col class="col_value top20">
                    <textarea v-model="form.creationIntentions" placeholder="请输入创作意图,限500字内" maxlength="500"></textarea>
                    <span>(选填)</span>
                </Col>
            </Row>
            <hr style="height:1px;border:none;border-top:1px solid #CBCBCB;"/>
            <Row class-name="row_item_1" style="min-height: 202px;">
                <Col class="col_label top20"><p>作品独创性：</p></Col>
                <Col class="col_value top20">
                    <textarea v-model="form.creationOriginality" placeholder="请输入作品独创性,限500字内"
                              maxlength="500"></textarea>
                    <span>(选填)</span>
                </Col>
            </Row>

            <div v-show="userInfo && userInfo!='' && !isReset ">
                <hr style="height:1px;border:none;border-top:1px solid #CBCBCB;"/>
                <Row style="height: auto;" class-name="row_item_1">
                    <Col class="col_label top20"><p>支付方式：</p></Col>
                    <Col class="col_value top20">
                        <component :is="PayWay" @onselected="handlePayWaySelect" type="0202"></component>
                    </Col>
                </Row>
            </div>

            <hr style="height:1px;border:none;border-top:1px solid #CBCBCB;"/>
            <Row class-name="row_item">
                <Col>
                    <button class="btn_blue" style="margin-left: 552px;" :disabled="isDisabled" @click="addcert">提交
                    </button>
                </Col>
            </Row>

            <CertAutorVerify v-if="isAddAutor" :obligeeArr="chooseObligeeArr" :is-radio="powerIsRadio"
                             :my-title="verifyTitle" @fatherModal="chooseAutor"/>
            <DeclareSample v-show="isShowDeclare" :declare-type="declareSrc" @fatherModal="isShowDeclare=false"/>
        </div>
        <div style="height: 60px;"></div>
    </div>


</template>

<script>
    import {cityCode} from "../../../libs/cityCode";
    import {_obligeeList, _getByPage} from "@/api/obligee.js";
    import {_save, _getDetail, _resubmit, _getWorkTypeList} from "../../../api/register";
    import Cookies from "js-cookie";
    import MyUploadHw from '@/views/main-components/my-upload-hw';
    import PayWay from '@/views/main-components/pay-way';
    import Timeline from '@/views/main-components/horizontal-timeline';
    import CertAutorVerify from "./cert-autor-verify";
    import '@/plugins/element.js';
    import DeclareSample from "./declareSample";
    import {_saveData, _getObligeeParams} from "./cpRegistData";
    // import ex_cascader from "../../../libs/ex_cascader";
    import "../../../plugins/element.js"
    import util from "../../../libs/util";
    import $ from "jquery";

    const reImg = /^(bmp|BMP|png|PNG|jpg|JPG|gif|GIF|jpeg|JPEG)$/;
    const reMusic = /^(cd|ogg|mp3|asf|wma|wav|mp3pro|real|ape|module|midi|vqf)$/;
    const reText = /^(doc|docx|dotx|dot|rtf|txt|htm|html|pdf|odt|docm|dotm|xml|mht|csv|xls|xlsx|xltx|xlt|pptx|ppt|potx|pot|pps|ppsx|odp|rp|eddx|mmap|vsd|vsdx|wps|dps|et|numbers|key|pages)$/;
    const reVideo = /^(avi|rmvb|rm|asf|divx|mpg|mpeg|mpe|wmv|mp4|mkv|vob|3gp|dat|mov|mpa|wvx|asx|ts|flv)$/;


    export default {
        metaInfo: {
            title: '版权登记|版权保护-版权服务专家',
            meta: [{                 // set meta
                name: 'keyWords',
                content: '版权服务,版权百科,版权,版权家,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
            }, {
                name: 'Description',
                content: '版权监测,版权家,人人都是创作者，人人都是版权人。版权家秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
            }]
        },
        name: "copyrightRegistration",
        components: {
            MyUploadHw,
            Timeline,
            CertAutorVerify,
            DeclareSample,
            PayWay
        },
        data() {
            return {
                comp_width: 320,
                test: ["中国", "北京市", "东城区"],
                // test:["0","110000","110101"],
                originObligeeArr: [],//著作权人的数据
                chooseObligeeArr: [], //点击弹窗，里面的内容
                isAddAutor: false, //是否添加作者/著作权人
                citys: [], //城市
                getObligeeParams: [], //获取作者/著作权人的参数

                completeCityIsOther: false,
                ohterCompleteCity: "",
                publishCityIsOther: false,
                ohterPublishCity: "",
                //作品类型
                // workTypes:[{label:"设计手稿",value:"1"},{label:"设计图",value:"2"},{label:"产品摄影",value:"3"},{label:"产品视频",value:"4"},{label:"设计创意稿",value:"5"}],//作品类型
                workTypes: [],//作品类型
                //作品性质
                creativeTypes: [
                    {label: "原创", value: "1"}, {label: "改编", value: "2"}, {label: "翻译", value: "3"},
                    {label: "汇编", value: "4"}, {label: "注释", value: "5"}, {label: "整理", value: "6"}, {
                        label: "其他",
                        value: "7"
                    }
                ],
                publishStatusArr: [{label: "未发表", value: "0"}, {label: "已发表", value: "1"}],

                isShowDeclare: false, //显示合作声明图片
                declareSrc: "3", //查看声明图片地址
                declare_down_urls: ["", "", "https://file.bqj.cn/file/acc22d35025a28b80d9bc578bf108b58.docx",
                    "",
                    "https://pub-bluefile.bqj.cn/urkunde/3211eb99fb9c16907cdec30886a2aad0.docx",
                    "https://pub-bluefile.bqj.cn/urkunde/bbd17aee92606185f38f2a6520b99e06.docx"
                ],//声明 下载地址
                guaranteeTemplet: ["https://pub-bluefile.bqj.cn/urkunde/76a366cf16a21dc2a9e4f9be03237866.docx",//权利保证书
                "https://pub-bluefile.bqj.cn/urkunde/09a46b467450e1c6d4fe82b71ad72cf9.docx"],//监护人承诺保证书
                declare_file_names: ["", "", "合作作品创作声明", "", "职务作品创作声明", "委托作品创作声明"],
                declare_upload_success: false,
                declare_file_name: "",
                // 1.个人作品 2.合作作品 3.法人作品 4.职务作品 5.委托作品
                powers: [{label: "个人作品", checked: true, value: "1"}, {label: "法人作品", checked: false, value: "3"},
                    {label: "合作作品", checked: false, value: "2"}, {label: "职务作品", checked: false, value: "4"},
                    {label: "委托作品", checked: false, value: "5"}],
              powerBys: [{label: "原始", checked: true, value: "1"}, {label: "继承", checked: false, value: "2"},
                {label: "承受", checked: false, value: "3"}, {label: "其他", checked: false, value: "4"}],
                powers_desArr: ["个人作品是指个人独立创作完成的作品。",
                    "合作作品是指两个人或者两人以上共同创作完成的作品。",
                    "法人作品是指以公司的名字创作完成的作品，著作权归属于公司。",
                    "职务作品是指企业事业职工履行工作职责或利用单位组织技术条件创作完成的作品，作品归属于单位，但创作人享有署名权和获得奖励的权力。",
                    "委托作品是指委托他人创作完成的作品，作品的权利归属可以依据委托合同约定。"],
                powers_des: "个人作品是指个人独立创作完成的作品。",
                ////权力权属
                Ownership: [
                    {label: '发表权', value: '1', checked: false},
                    {label: '署名权', value: '2', checked: false},
                    {label: '修改权', value: '3', checked: false},
                    {label: '复制权', value: '5', checked: false},
                    {label: '发行权', value: '6', checked: false},
                    {label: '保护作品完整权', value: '4', checked: false},
                    {label: '出租权', value: '7', checked: false},
                    {label: '展览权', value: '8', checked: false},
                    {label: '表演权', value: '9', checked: false},
                    {label: '放映权', value: '10', checked: false},
                    {label: '广播权', value: '11', checked: false},
                    {label: '信息网络传播权', value: '12', checked: false},
                    {label: '摄制权', value: '13', checked: false},
                    {label: '改编权', value: '14', checked: false},
                    {label: '翻译权', value: '15', checked: false},
                    {label: '汇编权', value: '16', checked: false},
                    {label: '其他', value: '17', checked: false},
                ],//权益拥有情况
                declare_fileAccept: ".png,.jpg",
                declare_fileFormat: [".png", ".jpg"],
                autors: [], //作者
                obligees: [],//权人

                worksList: [],//作品
                displayImageList: [],//作品
                enclosureList: [],//附件
                statementList: [],//创作声明
                publishUrlList: [],//已发表的截图或照片
                productImageUploadFileList: [],//作品展示图
                autGuarAnnexUploadFileList: [],//权利保证书
                publishUrl: "",
                powerIsRadio: "false",
                maxNumber: 6,
                displayImageMaxNumber: 1,
                form: {},
                copyrightDetailsId: "",
                isReset: false,
                keepAliveData: {},
                oldCopyrightType: "1",
                oldWorkType: "",
                userInfo: Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : '',
                flagId: '', //存证ID
                PayWay: '',
                isDisabled: false,
                workType_fileAccept: "*",
                rules: {
                    name: [
                        {required: true, message: '请输入活动名称', trigger: 'blur'}
                    ], //音乐名称
                    files: [{required: true, message: '请选择文件', trigger: 'blur'}], //音乐文件
                    autor: [{required: true, message: '请添加权利人', trigger: 'blur'}], //作者
                    obligee: [{required: true, message: '请添加权利人', trigger: 'blur'}],//权人
                },
                music: require('@/assets/common/music_icon.png'),
                text: require('@/assets/common/text_icon.png'),
                video: require('@/assets/common/video_icon.png'),
                other: require('@/assets/common/file_icon.png'),
                unCheckedIcon: require("@/assets/common/unChecked.png"),
                checkedIcon: require("@/assets/common/new_lo_ye.png"),
                options_create: {
                    disabledDate(date) {
                        //如果可以包含当天，那么 就不用减去8640000，如果不能包含当天，则需要减去
                        return date && date.valueOf() > Date.now();
                    }
                },
                options_publish: {
                    disabledDate: (date) => {
                        // console.log(this.form.completeDateEnd);
                        let d = new Date(this.form.completeDateEnd);
                        // console.log("d ====>>>> ",d);
                        return date && !(date.valueOf() < Date.now() && date.valueOf() >= d);
                    }
                },
                placeOfCompletion: [], //作品完成地点
                placeOfPublication: [], //作品发表地点
                otherFileFormat:"",
                displayImageFormat:".jpg,.JPG,.png,.PNG,jpeg,.JPEG",
                workFullNameLength: 0,
                signature:"", //署名
                signatureLength: 0, //署名长度
                reSubmitDisabled: true,
            }
        },
        created() {
            console.log("created :::::::::: ", _saveData);
            this.getWorkTypeList();
            this.getObligeeParams = _getObligeeParams;

            let _this = this;
            let userInfo = Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : "";


            if (this.$route.query.id && this.$route.query.id != '') {
                this.copyrightDetailsId = this.$route.query.id;
                this.flagId = this.$route.query.id;
                this.isReset = true;
                this.getDetail();
            } else {
                this.form = JSON.parse(JSON.stringify(_saveData));
            }

            if (userInfo) {
                this.getByPage(this.getObligeeParams.registerId = userInfo.id);
            }
            this.$store.state.app.showPayWay = Cookies.get("userInfo") && Cookies.get("userInfo") != '' ? true : false
            this.PayWay = this.$store.state.app.showPayWay ? 'PayWay' : ''

            this.timer = setInterval(() => {
                this.getObligee()
            }, 10000);
        },
        mounted() {
            this.citys = cityCode;
        },

        computed: {
            isSlectedAll: {
                get() {
                    let isAll = true;
                    this.Ownership.forEach(item => {
                        if (item.checked == false) {
                            isAll = false;
                            return;
                        }
                    })
                    return isAll;
                },
                set(value) {
                    this.selectAll(value);
                }
            }
        },
        methods: {
            changeCompleteDateEnd(e,w){
                if(this.form.publishStatus == 1){
                    let a =new Date(e);
                    let b=a.getTime(a);
                    if(this.form.publishDate==""){

                    }else{
                        let c= this.form.publishDate.getTime(this.form.publishDate);
                        if(b>c){
                            this.form.publishDate = ""
                        }
                    }
                }else{
                    this.form.publishDate = ""
                }
            },
            handlePayWaySelect(e) {
                console.log(e);
                this.payWay = e;
            },
            getObligee(){
              let userInfo = Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : "";
              if (userInfo) {
                this.getByPage(this.getObligeeParams.registerId = userInfo.id);
              }
            },
            /*********获取作者/著作权人***************/
            async getByPage(parms, flag = false) {
                // //debugger;
                let _this = this;
                let res = await _obligeeList(parms);
                if (res.code == "200") {
                    let data = res.result;
                    data.forEach(item => {
                        item.checked = false;
                    });
                    _this.originObligeeArr = data;
                    if (flag == true) {
                        //作者处理 originObligeeArr
                        _this.autors = [];
                        if (_this.form.authorIds) {
                            _this.form.authorIds.forEach(value => {
                                console.log(value);
                                for (let i = 0; i < _this.originObligeeArr.length; i++) {
                                    console.log(_this.originObligeeArr[i]);
                                    if (_this.originObligeeArr[i].id == value)
                                        _this.autors.push(_this.originObligeeArr[i]);
                                }
                            });
                        }
                        //著作权人处理
                        // //debugger ;
                        _this.obligees = [];
                        if (_this.form.powerIds) {
                            _this.form.powerIds.forEach(value => {
                                for (let i = 0; i < _this.originObligeeArr.length; i++) {
                                    if (_this.originObligeeArr[i].id == value)
                                        _this.obligees.push(_this.originObligeeArr[i]);
                                }
                            });
                        }
                    }
                }

            },
            /************获取登记详情***********/
            getDetail() {
                let _this = this;
                let data = {orderSeqNo: this.copyrightDetailsId};
                _getDetail(data).then(res => {
                    if (res.code == 200) {

                        _this.form = JSON.parse(JSON.stringify(_saveData));
                        //后来的数据返回来的是null,但是传值的时候，后端又不接受null
                        let _result = res.result;
                        let keys = Object.keys(_result);
                        keys.forEach((key) => {
                            if (_result[key] == null) {
                                _result[key] = "";
                            }
                        })
                        _this.form = Object.assign(_this.form, _result);
                        // _this.form = res.result;
                        //特殊处理，数据库返回来得字段，与传值字段不一样
                        _this.form.workType = _this.form.workType;//文字，看一会是不是需要转化成数字
                        for(let i in _this.form.workType){
                            if(_this.form.workType[i].pCode == "other"){
                                let sx = _this.form.workType[i].fileFormat.split('|');
                                let newF = [];
                                sx.map((item) => {
                                    newF.push('.' + item)
                                })
                                _this.otherFileFormat=newF.join(',')
                            }
                        }
                        //作品类型 处理
                        _this.workTypeChange(_this.form.workType)

                        let worksAttachmentses = _this.form.worksAttachmentses;
                        _this.form.attachementsUrl = _this.form.worksAttachments;
                        _this.form.completeDateEnd = _this.form.completeDate;
                        //权力权属，获取到得是文字
                        _this.powers_des = this.powers_desArr[parseInt(_this.form.copyrightType) - 1];
                        _this.oldCopyrightType = _this.form.copyrightType;


                        //作品文件处理
                        _this.worksList = [];

                        //截图
                      if(_this.form.publishPlatform != '') {
                        let publishUrlObj = {};
                        publishUrlObj.url = _this.form.publishPlatform;
                        publishUrlObj.name = '截图';
                        _this.publishUrlList.push(publishUrlObj);
                        _this.form.publishUrl = _this.form.publishPlatform;
                      }

                        // debugger ;
                        worksAttachmentses.forEach((value, index) => {
                            console.log(value);
                            let obj = {};
                            obj.attachmentUrl = value.url;
                            let layout = value.url.substring(value.url.lastIndexOf('.') + 1)
                            if (reImg.test(layout)) {
                                obj.url = util.thumbnail(value.url);
                            } else if (reMusic.test(layout)) {
                                obj.url = _this.music;
                            } else if (reText.test(layout)) {
                                obj.url = _this.text;
                            } else if (reVideo.test(layout)) {
                                obj.url = _this.video;
                            } else {
                                obj.url = _this.other;
                            }
                            obj.name = value.attachmentName;
                            obj.size = (value.attachmentSize) - 0;
                            _this.worksList.push(obj);
                        });


                        //时间得处理

                        //完成 地点得处理
                        let placeOfCompletionReflexion = _this.placeOfCompletionReflexion(_this.form);
                        _this.placeOfCompletion = placeOfCompletionReflexion.placeOfCompletion;


                        //附件处理
                        if (_this.form.otherAttachments != "" || _this.form.otherAttachments != null) {
                            _this.enclosureList = [];
                            let otherAttachments = (_this.form.otherAttachments).split(',');
                            if (otherAttachments[0] != "") {
                                otherAttachments.forEach((value, index) => {
                                    let obj = {};
                                    obj.attachmentUrl = value;
                                    obj.url = util.thumbnail(value);
                                    let layout = value.substring(value.lastIndexOf('.') + 1)
                                    if(reImg.test(layout)){
                                        obj.url = util.thumbnail(obj.url);
                                    }else if(reMusic.test(layout)){
                                        obj.url = _this.music;
                                    }else if(reText.test(layout)){
                                        obj.url = _this.text;
                                    }else if(reVideo.test(layout)){
                                        obj.url = _this.video;
                                    }else{
                                        obj.url = _this.other;
                                    }
                                    obj.name = "附件" + (index + 1) + "." + layout;

                                    _this.enclosureList.push(obj);
                                });
                            } else {
                                _this.form.otherAttachments = "";
                            }
                        }

                      //作品展示图处理
                      if (_this.form.productImageAttachments != "" || _this.form.productImageAttachments != null) {
                        _this.productImageUploadFileList = [];
                        let productImageAttachments = (_this.form.productImageAttachments).split(',');
                        if (productImageAttachments[0] != "") {
                          productImageAttachments.forEach((value, index) => {
                            let obj = {};
                            obj.attachmentUrl = value;
                            obj.url = util.thumbnail(value);
                            let layout = value.substring(value.lastIndexOf('.') + 1)
                            if(reImg.test(layout)){
                              obj.url = util.thumbnail(obj.url);
                            }else if(reMusic.test(layout)){
                              obj.url = _this.music;
                            }else if(reText.test(layout)){
                              obj.url = _this.text;
                            }else if(reVideo.test(layout)){
                              obj.url = _this.video;
                            }else{
                              obj.url = _this.other;
                            }
                            obj.name = "附件" + (index + 1) + "." + layout;

                            _this.productImageUploadFileList.push(obj);
                          });
                        } else {
                          _this.form.productImageAttachments = "";
                        }
                      }

                      //权利保证书
                      if (_this.form.autGuarAnnexAttachments != "" || _this.form.autGuarAnnexAttachments != null) {
                        _this.autGuarAnnexUploadFileList = [];
                        let autGuarAnnexAttachments = (_this.form.autGuarAnnexAttachments).split(',');
                        if (autGuarAnnexAttachments[0] != "") {
                          autGuarAnnexAttachments.forEach((value, index) => {
                            let obj = {};
                            obj.attachmentUrl = value;
                            obj.url = util.thumbnail(value);
                            let layout = value.substring(value.lastIndexOf('.') + 1)
                            if(reImg.test(layout)){
                              obj.url = util.thumbnail(obj.url);
                            }else if(reMusic.test(layout)){
                              obj.url = _this.music;
                            }else if(reText.test(layout)){
                              obj.url = _this.text;
                            }else if(reVideo.test(layout)){
                              obj.url = _this.video;
                            }else{
                              obj.url = _this.other;
                            }
                            obj.name = "附件" + (index + 1) + "." + layout;

                            _this.autGuarAnnexUploadFileList.push(obj);
                          });
                        } else {
                          _this.form.autGuarAnnexAttachments = "";
                        }
                      }


                        //发表地点的 处理
                        let placeOfPublicationReflexion = _this.placeOfPublicationReflexion(_this.form);
                        _this.placeOfPublication = placeOfPublicationReflexion.placeOfPublication;

                        //创作声明
                        if (_this.form.copyrightType == "2" || _this.form.copyrightType == "4" || _this.form.copyrightType == "5") {

                            _this.statementList[0] = {
                                attachmentUrl: _this.form.workInstruction,
                                url: _this.form.workInstruction,
                                name: "创作声明"
                            };
                            this.declare_file_name = _this.declare_file_names[Number(_this.form.copyrightType)] + _this.form.workInstruction.substr(_this.form.workInstruction.length - 4, 4);
                            _this.declare_upload_success = true; //显示创作声明的文本标签是否显示
                        }
                        //权力权益
                        _this.form.powerScope.split(",").forEach(value => {
                            _this.Ownership[value - 1].checked = true;
                        })

                        //创作意图
                        _this.form.creationIntentions = _this.form.creationIntentions;

                        _this.getByPage(this.getObligeeParams, true);
                        _this.form.workFullname = _this.getStrByLength(_this.form.workFullname, 60);
                        _this.workFullNameLength = _this.getLength(_this.form.workFullname);
                        _this.signature = _this.getStrByLength(_this.form.signature, 18);
                        _this.signatureLength = _this.getLength(_this.form.signature);
                    }
                }, (err) => {
                    toast('网络断开连接，请重试')
                })
            },

            //通过名称获取value，用于权力权属，作品类型，作品性质，发表状态
            getValueByLabel(name, originArr) {
                let value = "";
                originArr.forEach(item => {
                    if (item.label == name)
                        value = item.value;
                });
                return value;
            },

            powerChange(e, q) {
                console.log(e, q);
                if (!this.checkUploading()) {
                    toast('请上传完成，再进行操作');
                    this.$nextTick(() => {
                        this.form.copyrightType = this.oldCopyrightType;
                    })

                    return false
                }
                let index = parseInt(this.form.copyrightType) - 1;
                this.powers_des = this.powers_desArr[index];
                //如果权力权益发生变化，那么，创作声明都需要重新上传文件
                let currValue = this.form.copyrightType;
                this.declare_file_name = "";
                this.placeOfCompletion = [];
                this.placeOfPublication = [];
                this.declare_upload_success = false;
                // if(this.keepAliveData[this.oldCopyrightType] == null){
                var obj = {};
                obj.form = {...this.form};
                obj.autors = [...this.autors];
                obj.obligees = [...this.obligees];
                obj.worksList = [...this.worksList];//作品
                obj.enclosureList = [...this.enclosureList];//附件
                obj.statementList = [...this.statementList];//创作声明
                //obj.publishUrlList = [...this.publishUrlList];//已发表的截图或照片
                obj.Ownership = JSON.parse(JSON.stringify(this.Ownership)); //权益拥有情况
                obj.Ownership = JSON.parse(JSON.stringify(this.Ownership)); //权益拥有情况
                //完成 地点得处理
                let placeOfCompletionReflexion = this.placeOfCompletionReflexion(obj.form);
                obj.placeOfCompletion = placeOfCompletionReflexion.placeOfCompletion;
                //发表地点得处理
                let placeOfPublicationReflexion = this.placeOfPublicationReflexion(obj.form);
                obj.placeOfPublication = placeOfPublicationReflexion.placeOfPublication;


                this.keepAliveData[this.oldCopyrightType] = {...obj};
                // }
                //把当前的权利归属字段赋给记录字段
                this.oldCopyrightType = this.form.copyrightType;

                if (this.keepAliveData[this.form.copyrightType] != null) {
                    let obj = {...this.keepAliveData[this.form.copyrightType]};
                    this.form = obj.form;
                    this.autors = obj.autors;
                    this.obligees = obj.obligees;
                    this.worksList = obj.worksList;
                    this.enclosureList = obj.enclosureList;
                    this.statementList = obj.statementList;
                    this.Ownership = obj.Ownership;
                    this.placeOfCompletion = obj.placeOfCompletion;
                    this.placeOfPublication = obj.placeOfPublication
                    console.log(this.statementList)
                    if (this.statementList && this.statementList.length != '') {
                        this.declare_file_name = this.declare_file_names[Number(this.form.copyrightType)] + this.form.workInstruction.substr(this.form.workInstruction.length - 4, 4);
                        this.declare_upload_success = true;
                    }
                } else {
                    if (currValue == "2" || currValue == '4' || currValue == '5') {
                        this.$refs['stateFile'].clearUploadList();
                    }
                    this.form = JSON.parse(JSON.stringify(_saveData));
                    this.autors = [];
                    this.obligees = [];
                    this.worksList = [];
                    this.statementList = [];
                    this.enclosureList = [];
                    this.isSlectedAll = false;
                }

                this.$refs["workFile"].clearUploadList();
                this.$refs['encolosureFile'].clearUploadList();
                this.$refs['stateFile'].clearUploadList();

                //this.$refs['publishUrlFile'].clearUploadList();
                this.workTypeChange(this.form.workType)
                //这里需要把当前的权利归属字段重新赋值给form,因为这里form进行了重新赋值，而_saveData里面，权利归属的初始值是1，是个人
                this.form.copyrightType = currValue;
            },
            //作品类型发生改变
            workTypeChange(e) {
                console.log(e);
                if (!e || e == '') {
                    this.$refs['worksType'].clearSingleSelect();
                    this.form.workType = !e ? '' : e;
                    this.form.workTypeDesc = '';
                    this.workType_fileAccept = '*';
                    this.oldWorkType = !e ? '' : e;
                    return false
                }


                let oldWorkType = this.oldWorkType;
                let workTypes = this.workTypes;
                let workItem = '';
                let wl = this.worksList;

                for (let k = 0; k < wl.length; k++) {
                    if (wl[k].status && wl[k].status == 'uploading') {
                        toast('请上传完成后，再进行操作');
                        this.$nextTick(() => {
                            this.form.workType = oldWorkType;
                        })
                        return;
                    }
                }


                for (let i = 0; i < workTypes.length; i++) {
                    if (e == workTypes[i].code) {
                        workItem = workTypes[i];
                        break;
                    }
                }


                let fileFormat = workItem.fileFormat && workItem.fileFormat != '' ? '.' + workItem.fileFormat.replace(/\|/g, ',.') : '*';
                this.form.workTypeDesc = workItem.pCode;
                this.workType_fileAccept = fileFormat;
                console.log(this.workType_fileAccept);


                // if(fileFormat!='*'){
                //     if (wl.length > 0) {
                //         let j = wl.length;
                //         while (j--) {
                //             let layout = wl[j].attachmentUrl.substring(wl[j].attachmentUrl.lastIndexOf('.') + 1);
                //             if (this.workType_fileAccept.indexOf(layout) == -1) {
                //                 wl.splice(j, 1);
                //             }
                //         }
                //     }
                // }


                this.oldWorkType = e;

            },

          workFullnameChange(){
            let _this = this;
            let wfn = _this.form.workFullname;
            if(this.getLength(wfn) > 60){
              toast('最多支持60个字符')
            }
            wfn = _this.getStrByLength(wfn, 60);
            let len = _this.getLength(wfn);

            this.form.workFullname = wfn;
            this.workFullNameLength = len;
          },
          signatureChange(){
            let _this = this;
            let s = _this.form.signature;
            if(this.getLength(s) > 18){
              toast('最多支持18个字符')
            }
            s = _this.getStrByLength(s, 18);
            let len = _this.getLength(s);

            this.form.signature = s;
            this.signatureLength = len;
          },

          getLength(str){
            let len = str.length;
            let reLen = 0;
            for(let i=0;i < len;i++){
              if(str.charCodeAt(i) < 27 || str.charCodeAt(i) > 126){
                reLen += 2;
              }else{
                reLen++;
              }
            }
            return reLen;
          },

          getStrByLength(str, length){
            let _this = this;
            let resultStr = '';
            let len = str.length;
            let reLen = 0;
            for(let i=0;i < len;i++){
              if(str.charCodeAt(i) < 27 || str.charCodeAt(i) > 126){
                reLen += 2;
              }else{
                reLen++;
              }
            }
            while(reLen > length){
              str = _this.getStrByLength(str.slice(0, -1),  length)
              reLen = _this.getLength(str);
            }
            resultStr = str
            return resultStr;
          },


            //添加作者，弹出添加作者窗口
          addAutor(flag) {
            if (!this.checkLogin()) {
              return false;
            }

            this.autorOrObligee = flag;
            this.verifyTitle = this.autorOrObligee === "autor" ? "选择作者" : "选择著作权人";

            let data = [];
            let radioMode = "false";

            console.log("版权类型:", this.form.copyrightType);
            console.log("选择类型:", this.autorOrObligee);

            // 根据版权类型过滤数据
            switch (this.form.copyrightType) {
              case "1": // 个人作品
                data = this.originObligeeArr.filter(item => item.obligeeType === "person");
                radioMode = "true";  // 单选（作者和著作权人是一个人）
                if (data.length === 0) {
                  toast("您还没有添加个人权利人，请先添加个人权利人再来登记");
                  return false;
                }
                break;

              case "3": // 法人作品
                data = this.originObligeeArr.filter(item => item.obligeeType === "enterprise");
                radioMode = "true";  // 单选
                if (data.length === 0) {
                  toast("您还没有添加企业权利人，请先添加企业权利人再来登记");
                  return false;
                }
                break;

              case "4": // 职务作品
                if (this.autorOrObligee !== "autor") {
                  radioMode = "true";  // 著作权人单选
                } else {
                  radioMode = "false";  // 作者多选
                }
                data = this.originObligeeArr;
                if (data.length === 0) {
                  toast("您还没有添加权利人，请先添加权利人再来登记");
                  return false;
                }
                break;

              default: // 其他情况
                radioMode = "false";
                data = this.originObligeeArr;
                if (data.length === 0) {
                  toast("您还没有添加权利人，请先添加权利人再来登记");
                  return false;
                }
                break;
            }

            this.powerIsRadio = radioMode;

            // 深拷贝数据并添加 checked 状态
            this.chooseObligeeArr = data.map(item => {
              const newItem = { ...item };

              // 回显已选中的状态
              if (this.autorOrObligee === "autor") {
                newItem.checked = this.autors.some(v => v.id === item.id);
              } else {
                newItem.checked = this.obligees.some(v => v.id === item.id);
              }

              return newItem;
            });

            this.isAddAutor = true;
          },
            //关闭 添加作者窗口，获取选中得作者
          chooseAutor(data) {
            console.log('选中的数据:', data);
            this.isAddAutor = false;

            // 如果没有选择任何数据，直接返回
            if (!data || data.length === 0) {
              return;
            }

            // 个人作品：作者和著作权人是一个人，选择一个，两个都变
            if (this.form.copyrightType == "1") {
              // ✅ 直接替换，保持选择顺序
              this.autors = [...data];
              this.obligees = [...data];
            }
            // 法人作品：作者和著作权人只能选一个
            else if (this.form.copyrightType == "3") {
              if (this.autorOrObligee == "autor") {
                // ✅ 直接替换，保持选择顺序
                this.autors = [...data];
              } else {
                // ✅ 直接替换，保持选择顺序
                this.obligees = [...data];
              }
            }
            // 职务作品：著作权人只能是一个（单选）
            else if (this.form.copyrightType == "4" && this.autorOrObligee != "autor") {
              // ✅ 直接替换，保持选择顺序（单选只有一个）
              this.obligees = [...data];
            }
            // 其他情况：追加到已有列表
            else {
              if (this.autorOrObligee === "autor") {
                // ✅ 改造：使用 push 追加，保持选择顺序
                // 先过滤掉已存在的，再追加
                const newItems = data.filter(item =>
                    !this.autors.some(v => v.name === item.name)
                );
                this.autors.push(...newItems);  // push 保持顺序
              } else if (this.autorOrObligee === "obligee") {
                // ✅ 改造：使用 push 追加，保持选择顺序
                const newItems = data.filter(item =>
                    !this.obligees.some(v => v.name === item.name)
                );
                this.obligees.push(...newItems);  // push 保持顺序
              }
            }

            // 可选：打印当前选择的顺序
            console.log('当前作者顺序:', this.autors.map(v => v.name));
            console.log('当前著作权人顺序:', this.obligees.map(v => v.name));
          },

          // 删除作者
          deleteAutor(item) {
            // ✅ 改造：使用 findIndex 查找并删除，保持顺序
            const index = this.autors.findIndex(v => v.name === item.name);
            if (index !== -1) {
              this.autors.splice(index, 1);  // splice 删除后保持顺序
            }
          },

          // 删除著作权人
          deleteObligee(item) {
            // ✅ 使用 findIndex 查找并删除，保持顺序
            const index = this.obligees.findIndex(v => v.name === item.name);
            if (index !== -1) {
              this.obligees.splice(index, 1);
            }
          },

            //查看声明样例
            showDeclareSample() {
                this.declareSrc = this.form.copyrightType;
                this.isShowDeclare = true;
            },

            //提交
            addcert() {
                // $("#addcertButton").attr("disabled","disabled");
                let _this = this;
                if (!this.checkLogin()) {
                    return false
                }
              let userInfo = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
                console.log("form ::: >>> ", _this.form);

                if(_this.autors.length > 5 || _this.obligees.length > 5){
                  toast("作者和著作权人最多支持5个");
                  return false;
                }
                /**
                 * 判断作者和著作权人
                 * 1 判断是否为空
                 * 2 如果是合作作品 ，则作者和著作权人都必须大于等于2
                 */
                console.log("_this.autors", _this.autors);
                if (_this.autors.length <= 0 || _this.obligees.length <= 0) {
                    toast("请选择作者和著作权人");
                    return false;
                } else if (_this.form.copyrightType == "2" && (_this.autors.length < 2 || _this.obligees.length < 2)) {
                    toast("合作作品，作者和著作权人都必须大于等于2个");
                    return false;
                } else {
                    let aid = "";
                    let oid = "";
                    _this.autors.forEach(item => {
                        aid += item.id + ",";
                    })
                    _this.obligees.forEach(item => {
                        oid += item.id + ",";
                    })
                    _this.form.authorIds = aid.substr(0, aid.length - 1);
                    _this.form.obligeeIds = oid.substr(0, oid.length - 1);
                }

                //判断 作品类型
                // debugger ;
                if (_this.form.workType == "") {
                    toast("请选择作品类型")
                    return false;
                } else {
                    _this.form.workType = _this.form.workType;
                }

                //判断作品名称
                if (_this.form.workFullname == "") {
                    toast("请填写作品名称")
                    return false;
                }

                //判断作品文件
                if (_this.worksList.length <= 0) {
                    toast("请选择作品文件")
                    return false;
                } else {
                    let chanShowList = _this.worksList;
                    let urls = '';
                    let attachementsName = '';
                    let attachmentsSize = '';
                    for (let i = 0; i < chanShowList.length; i++) {
                        if (chanShowList[i].status && chanShowList[i].status == 'uploading') {

                            toast('请上传完成后，再提交');
                            return false
                        }

                        urls += i == chanShowList.length - 1 ? chanShowList[i].attachmentUrl : chanShowList[i].attachmentUrl + ',';
                        attachementsName += i == chanShowList.length - 1 ? chanShowList[i].name : chanShowList[i].name + ',';
                        attachmentsSize += i == chanShowList.length - 1 ? chanShowList[i].size : chanShowList[i].size + ',';
                    }
                    if (urls == '') {
                        toast('请选择要上传的作品文件')
                        return false;
                    } else {
                        _this.form.attachementsUrl = urls;
                        _this.form.attachementsName = attachementsName;
                        _this.form.attachmentsSize = attachmentsSize;
                    }
                }
                _this.form.displayImageUrl = _this.displayImageList.length>0?_this.displayImageList[0].attachmentUrl:"";

                //判断作品创作性质
                if (_this.form.creativeType == "") {
                    toast("请选择作品创作性质")
                    return false;
                } else {
                    _this.form.creativeType = _this.form.creativeType;
                }


                // 创作完成时间
                if (_this.form.completeDateEnd == "") {
                    toast("请选择创作完成时间")
                    return false;
                } else {
                    let dt = new Date(_this.form.completeDateEnd);
                    let year = dt.getFullYear();
                    let month = (dt.getMonth() + 1) >= 10 ? (dt.getMonth() + 1) : "0" + (dt.getMonth() + 1);
                    let date = dt.getDate() < 10 ? "0" + dt.getDate() : dt.getDate();
                    _this.form.completeDateEnd = year + "-" + month + "-" + date;
                }

                //作品完成地点
                if (!_this.placeOfCompletion || _this.placeOfCompletion == "") {
                    toast("请选择作品完成地点")
                    return false;
                } else if (_this.placeOfCompletion[0] == '其他') {
                    if (_this.form.completeCity == "") {
                        toast("请填写作品完成地点")
                        return false;
                    }
                    _this.form.completeCountry = '其他';
                    _this.form.completeProvince = '无';
                } else {
                    _this.form.completeCountry = _this.placeOfCompletion[0];
                    _this.form.completeProvince = _this.placeOfCompletion[1];
                    _this.form.completeCity = _this.placeOfCompletion[2];
                }
                if (!_this.form.publishStatus || _this.form.publishStatus == '') {
                    toast("请选择作品发表状态")
                    return false

                }
                _this.form.publishStatus = _this.form.publishStatus[0];
                //发表状态 如果时已发表，则判断发表时候的地点和时间
                if (_this.form.publishStatus == "1") {
                    //发表完成时间
                    if (_this.form.publishDate == "") {
                        toast("请选择作品发表时间")
                        return false;
                    } else {
                        let dt = new Date(_this.form.publishDate);
                        let year = dt.getFullYear();
                        let month = (dt.getMonth() + 1) >= 10 ? (dt.getMonth() + 1) : "0" + (dt.getMonth() + 1);
                        let date = dt.getDate() < 10 ? "0" + dt.getDate() : dt.getDate();
                        _this.form.publishDate = year + "-" + month + "-" + date;
                    }
                    //发表完成地点
                    console.log("作品发表地点：：：", _this.placeOfPublication);
                    if (!_this.placeOfPublication || _this.placeOfPublication == "") {
                        toast("请选择作品发表地点")
                        return false;
                    } else if (_this.placeOfPublication[0] == '其他') {
                        if (_this.form.publishCity == "") {
                            toast("请填写作品发表地点")
                            return false;
                        }
                        _this.form.publishCountry = '其他';
                        _this.form.publishProvince = '无';
                        // _this.form.publishCity = _this.ohterPublishCity;
                    } else {
                        _this.form.publishCountry = _this.placeOfPublication[0];
                        _this.form.publishProvince = _this.placeOfPublication[1];
                        _this.form.publishCity = _this.placeOfPublication[2];
                    }
                } else if (_this.form.publishStatus == "0") {
                  _this.form.publishCountry = '';
                  _this.form.publishProvince = '';
                  _this.form.publishCity = '';
                  _this.form.publishDate = '';
                  _this.form.publishPlatform = '';
                }
                // 附件 也可以为空
                if (_this.enclosureList.length > 0) {
                    let chanShowList = _this.enclosureList;
                    let urls = '';
                    for (let i = 0; i < chanShowList.length; i++) {
                        if (chanShowList[i].status && chanShowList[i].status == 'uploading') {

                            toast('请上传完成后，再提交');
                            return false
                        }
                        urls += i == chanShowList.length - 1 ? chanShowList[i].attachmentUrl : chanShowList[i].attachmentUrl + ',';
                    }
                    _this.form.otherAttachments = urls;
                }else{
                  _this.form.otherAttachments = ''
                }

              //作品展示图
              if (_this.productImageUploadFileList.length > 0) {
                let chanShowList = _this.productImageUploadFileList;
                let urls = '';
                for (let i = 0; i < chanShowList.length; i++) {
                  if (chanShowList[i].status && chanShowList[i].status == 'uploading') {
                    toast('作品展示图上传完成后再提交');
                    return false
                  }
                  urls += i == chanShowList.length - 1 ? chanShowList[i].attachmentUrl : chanShowList[i].attachmentUrl + ',';
                }
                _this.form.productImageAttachments = urls;
              }else{
                _this.form.productImageAttachments = ''
              }

              //权利保证书
              if (_this.autGuarAnnexUploadFileList.length > 0) {
                let chanShowList = _this.autGuarAnnexUploadFileList;
                let urls = '';
                for (let i = 0; i < chanShowList.length; i++) {
                  if (chanShowList[i].status && chanShowList[i].status == 'uploading') {
                    toast('权利保证书上传完成后再提交');
                    return false
                  }
                  urls += i == chanShowList.length - 1 ? chanShowList[i].attachmentUrl : chanShowList[i].attachmentUrl + ',';
                }
                _this.form.autGuarAnnexAttachments = urls;
              } else {
                toast('请上传权利保证书');
                return false
              }

                if(_this.form.publishStatus == '1'){
                  if (_this.publishUrlList.length == 0){
                    toast('请上传已发表的截图或照片');
                    return false
                  }else if(_this.publishUrlList.length > 1){
                    toast('已发表的截图或照片附件仅支持提交一个');
                    return false
                  }
                }
                if (_this.publishUrlList.length > 0) {
                  let chanShowList = _this.publishUrlList;
                  let urls = '';
                  for (let i = 0; i < chanShowList.length; i++) {
                    if (chanShowList[i].status && chanShowList[i].status == 'uploading') {

                      toast('请上传完成后，再提交');
                      return false
                    }
                    urls += i == chanShowList.length - 1 ? chanShowList[i].attachmentUrl : chanShowList[i].attachmentUrl + ',';
                  }
                  if(urls == 'undefined') {
                    _this.form.publishUrl = '';
                  }else{
                    _this.form.publishUrl = urls;
                  }
                } else {
                  _this.form.publishUrl = "";
                }

                //创作声明的判断
                if (_this.form.copyrightType == "2" || _this.form.copyrightType == "4" || _this.form.copyrightType == "5") {
                    if (_this.statementList.length <= 0) {
                        toast("请选择创作声明")
                        return false;
                    } else {
                        let chanShowList = _this.statementList;
                        let urls = '';
                        for (let i = 0; i < chanShowList.length; i++) {
                            if (chanShowList[i].status && chanShowList[i].status == 'uploading') {
                                toast('请上传完成后，再提交');
                                return false
                            }
                            urls += i == chanShowList.length - 1 ? chanShowList[i].attachmentUrl : chanShowList[i].attachmentUrl + ',';
                        }
                        if (_this.urls == '') {
                            toast('请选择要上传的创作声明文件')
                            return false;
                        } else {
                            _this.form.workInstruction = urls;
                        }
                    }
                }

                //权益拥有情况
                let isHaveSelect = false;
                let powerScopeType = "";
                _this.Ownership.forEach(item => {
                    if (item.checked == true) {
                        isHaveSelect = true;
                        powerScopeType += item.value + ","
                    }
                });
                if (isHaveSelect == false) {
                    toast('请选择权益拥有情况')
                    return false;
                }
                console.log("powerScopeType :: ", powerScopeType);
                _this.form.powerScope = powerScopeType.substr(0, powerScopeType.length - 1);

                //独创性和创作意图可以为空
                // 提交

                //debugger ;
                console.log("登记的传参  :: ", _this.form);
                if (_this.isReset == true) {
                    _this.form.orderSeqNo = _this.copyrightDetailsId;
                    // _this.form.powerBy = "1";
                    _this.isDisabled = true;
                    _resubmit(_this.form).then(res => {
                        this.resultJ(res);
                    });

                } else {
                  if (userInfo.vipFlag === '0') {
                    toast('请购买会员后提交订单')
                    // $("#addcertButton").removeAttr("disabled");
                    return;
                  }

                    if (!_this.payWay) {
                        toast('无可用次数，请充值续费')
                        // $("#addcertButton").removeAttr("disabled");

                        return;
                    } else {
                        if (this.payWay.gift.activityGiftId) {
                            Object.assign(_this.form, {activityGiftId: this.payWay.gift.activityGiftId})
                        }
                    }
                    _this.isDisabled = true;
                    _save(_this.form).then(res => {
                        this.resultJ(res);
                    });
                }
            },
            resultJ(res) {
                console.log("登记提交后的返回结果：：：", res);
                if (res.code == 200) {
                    toast('登记保存成功')
                    this.$router.push({path: '/myDci'})
                } else if (res.code == 213) {
                    toast("请实名认证后使用功能")
                    this.$router.push('/authentication')
                } else if (res.code == 214) {
                    toast("请购买会员后使用功能")
                    if (userInfo.accountType == "person") {
                        this.$router.push('/vipPersonal')
                    } else {
                        this.$router.push('/vipEnterprise')
                    }
                } else if (res.code == 216) {
                    // this.monitorBagState = true;
                    // $("#addcertButton").removeAttr("disabled");
                    this.isDisabled = false
                } else if (res.code == 215) {
                    toast("VIP已到期，请续费")
                    this.myczPayState = true;
                    // $("#addcertButton").removeAttr("disabled");
                    this.isDisabled = false
                } else {
                    toast(res.message)
                    // $("#addcertButton").removeAttr("disabled");
                    this.isDisabled = false
                }

            },
          toClick(){
            if(this.isReset && this.reSubmitDisabled){
              toastNewline('请谨慎修改作品文件！\n' +
                  '作品文件任何变动均视为新订单，出证日期将重新计算！')
              this.reSubmitDisabled = false
            }
          },
            //上传作品文件
            showmessagefromchild(data) {
                let _this = this;
                for (let i = 0; i < data.length; i++) {
                    if (data[i].status && data[i].status == 'uploading') {
                        // console.log('没完成')
                        break
                    }
                    let layout = data[i].attachmentUrl.substring(data[i].attachmentUrl.lastIndexOf('.') + 1)
                    if (reImg.test(layout)) {
                        // if(data[i].url.indexOf('?x-image-process=image/resize,m_fixed,w_84,h_60') == -1){
                        //     data[i].url = data[i].url + '?x-image-process=image/resize,m_fixed,w_84,h_60'
                        // }
                        data[i].url = util.thumbnail(data[i].url);
                    } else if (reMusic.test(layout)) {
                        data[i].url = _this.music;
                    } else if (reText.test(layout)) {
                        data[i].url = _this.text;
                    } else if (reVideo.test(layout)) {
                        data[i].url = _this.video;
                    } else {
                        data[i].url = _this.other;
                    }
                }

                _this.worksList = data;
                this.$forceUpdate()

            },

          //上传作品文件
          showmessagefromchildDisplayImage(data) {
            let _this = this;
            for (let i = 0; i < data.length; i++) {
              if (data[i].status && data[i].status == 'uploading') {
                // console.log('没完成')
                break
              }
              let layout = data[i].attachmentUrl.substring(data[i].attachmentUrl.lastIndexOf('.') + 1)
              if (reImg.test(layout)) {
                // if(data[i].url.indexOf('?x-image-process=image/resize,m_fixed,w_84,h_60') == -1){
                //     data[i].url = data[i].url + '?x-image-process=image/resize,m_fixed,w_84,h_60'
                // }
                data[i].url = util.thumbnail(data[i].url);
              }
            }

            _this.displayImageList = data;
            this.$forceUpdate()
          },
            //删除作品文件
            deleteList(item) {
              if(this.isReset && this.reSubmitDisabled) {
                toastNewline('请谨慎修改作品文件！\n' +
                    '作品文件任何变动均视为新订单，出证日期将重新计算！')
                this.reSubmitDisabled = false;
              }
                // //debugger ;
                this.worksList.splice(this.worksList.indexOf(item), 1);
            },
            //上传附件
            showmessagefromchild1(data) {
                let _this = this;
                for (let i = 0; i < data.length; i++) {
                    if (data[i].status && data[i].status == 'uploading') {
                        // console.log('没完成')
                        break
                    }

                    let layout = data[i].attachmentUrl.substring(data[i].attachmentUrl.lastIndexOf('.') + 1)
                    if (reImg.test(layout)) {
                        // if(data[i].url.indexOf('?x-image-process=image/resize,m_fixed,w_84,h_60') == -1){
                        //     data[i].url = data[i].url + '?x-image-process=image/resize,m_fixed,w_84,h_60'
                        // }
                        data[i].url = util.thumbnail(data[i].url);
                    } else if (reMusic.test(layout)) {
                        data[i].url = _this.music;
                    } else if (reText.test(layout)) {
                        data[i].url = _this.text;
                    } else if (reVideo.test(layout)) {
                        data[i].url = _this.video;
                    } else {
                        data[i].url = _this.other;
                    }
                }
                console.log(data)
                _this.enclosureList = data
                this.$forceUpdate()
            },

          //上传作品展示图
          showmessagefromchild4(data) {
            let _this = this;
            for (let i = 0; i < data.length; i++) {
              if (data[i].status && data[i].status == 'uploading') {
                break
              }

              let layout = data[i].attachmentUrl.substring(data[i].attachmentUrl.lastIndexOf('.') + 1)
              if (reImg.test(layout)) {
                data[i].url = util.thumbnail(data[i].url);
              } else if (reMusic.test(layout)) {
                data[i].url = _this.music;
              } else if (reText.test(layout)) {
                data[i].url = _this.text;
              } else if (reVideo.test(layout)) {
                data[i].url = _this.video;
              } else {
                data[i].url = _this.other;
              }
            }
            console.log(data)
            _this.productImageUploadFileList = data
            this.$forceUpdate()
          },

          //上传权利保证书
          showmessagefromchild5(data) {
            let _this = this;
            for (let i = 0; i < data.length; i++) {
              if (data[i].status && data[i].status == 'uploading') {
                break
              }

              let layout = data[i].attachmentUrl.substring(data[i].attachmentUrl.lastIndexOf('.') + 1)
              if (reImg.test(layout)) {
                data[i].url = util.thumbnail(data[i].url);
              } else if (reMusic.test(layout)) {
                data[i].url = _this.music;
              } else if (reText.test(layout)) {
                data[i].url = _this.text;
              } else if (reVideo.test(layout)) {
                data[i].url = _this.video;
              } else {
                data[i].url = _this.other;
              }
            }
            console.log(data)
            _this.autGuarAnnexUploadFileList = data
            this.$forceUpdate()
          },
            //删除附件
            deleteList_fj(item) {
                this.enclosureList.splice(this.enclosureList.indexOf(item), 1);
            },
            deleteList_fj2(item) {
              this.publishUrlList.splice(this.publishUrlList.indexOf(item), 1);
            },
          deleteList_zst(item) {
            this.productImageUploadFileList.splice(this.productImageUploadFileList.indexOf(item), 1);
          },
          deleteList_bzs(item) {
            this.autGuarAnnexUploadFileList.splice(this.autGuarAnnexUploadFileList.indexOf(item), 1);
          },
            //创作声明，只有一个文件
            showmessagefromchild2(data) {
                let _this = this;

                if (data[0].status && data[0].status == 'uploading') {
                    // console.log('没完成')
                } else {
                    let layout = data[0].attachmentUrl.substring(data[0].attachmentUrl.lastIndexOf('.') + 1)
                    if (reImg.test(layout)) {
                        if (data[0].url.indexOf('?x-image-process=image/resize,m_fixed,w_84,h_60') == -1) {
                            data[0].url = data[0].url + '?x-image-process=image/resize,m_fixed,w_84,h_60'
                        }
                    } else {
                        data[0].url = _this.other;
                    }

                    _this.declare_upload_success = true;
                    _this.declare_file_name = _this.declare_file_names[_this.form.copyrightType] + "." + layout;

                }
                console.log('获取接口后的存证数据', data)
                _this.statementList = data
                this.$forceUpdate()
            },
            showmessagefromchild3(data) {
              let _this = this;
              for (let i = 0; i < data.length; i++) {
                if (data[i].status && data[i].status == 'uploading') {
                  // console.log('没完成')
                  break
                }
                let layout = data[i].attachmentUrl.substring(data[i].attachmentUrl.lastIndexOf('.') + 1)
                if (reImg.test(layout)) {
                  // if(data[i].url.indexOf('?x-image-process=image/resize,m_fixed,w_84,h_60') == -1){
                  //     data[i].url = data[i].url + '?x-image-process=image/resize,m_fixed,w_84,h_60'
                  // }
                  data[i].url = util.thumbnail(data[i].url);
                } else if (reMusic.test(layout)) {
                  data[i].url = _this.music;
                } else if (reText.test(layout)) {
                  data[i].url = _this.text;
                } else if (reVideo.test(layout)) {
                  data[i].url = _this.video;
                } else {
                  data[i].url = _this.other;
                }
              }

              _this.publishUrlList = data;
              this.$forceUpdate()
            },
            //权益拥有情况 全选
            selectAll(value) {
                this.Ownership.forEach(item => item.checked = value);
            },

            /***************************获取作品类型列表*************************/
            getWorkTypeList() {
                let _this = this;
                _getWorkTypeList().then(res => {
                    console.log(res);
                    if (res.code == 200) {
                        _this.workTypes = res.result;
                        for(let i in res.result){
                            if(res.result[i].pCode == "other"){
                                console.log(res.result[i])
                                let sx = res.result[i].fileFormat.split('|');
                                let newF = [];
                                sx.map((item) => {
                                    newF.push('.' + item)
                                })
                                _this.otherFileFormat = newF.join(',')
                                console.log(_this.otherFileFormat)
                            }
                        }
                    } else {
                        toast(res.message)
                    }
                })
            },

            /***************************作品完成地点改变事件*************************/
            placeOfCompletionChange(e) {
                let _this = this;
                //作品完成地点
                if (_this.placeOfCompletion == "") {
                    return false;

                } else if (_this.placeOfCompletion[0] == '其他') {
                    _this.form.completeCity = '';
                    _this.form.completeCountry = '其他';
                    _this.form.completeProvince = '无';
                } else {
                    _this.form.completeCountry = _this.placeOfCompletion[0];
                    _this.form.completeProvince = _this.placeOfCompletion[1];
                    _this.form.completeCity = _this.placeOfCompletion[2];
                }
            },

            /***************************作品发表地点改变事件*************************/
            placeOfPublicationChange(e) {
                let _this = this;

                console.log(e);
                console.log(_this.placeOfPublication)

                if (!_this.placeOfPublication || _this.placeOfPublication == "") {
                    return false;

                } else if (_this.placeOfPublication[0] == '其他') {
                    _this.form.publishCity = '';
                    _this.form.publishCountry = '其他';
                    _this.form.publishProvince = '无';
                } else {
                    _this.form.publishCountry = _this.placeOfPublication[0];
                    _this.form.publishProvince = _this.placeOfPublication[1];
                    _this.form.publishCity = _this.placeOfPublication[2];
                }
            },

            /***************************作品完成地点返显方法*************************/
            placeOfCompletionReflexion(form) {
                console.log(form)
                let arr = [];
                let ohterCompleteCity = '';
                arr.push(form.completeCountry);
                if (form.completeCountry == '其他') {
                    ohterCompleteCity = form.completeCity;
                } else {
                    arr.push(form.completeProvince);
                    arr.push(form.completeCity);
                }

                return {placeOfCompletion: arr, ohterCompleteCity: ohterCompleteCity}
            },

            /***************************作品发表地点返显方法*************************/
            placeOfPublicationReflexion(form) {
                let parr = [];
                let ohterPublishCity = '';
                if (form.publishStatus == "1") {

                    //发表地点的 处理
                    if (form.publishCity != "" || form.publishCity != null) {
                        parr.push(form.publishCountry);
                        if (form.publishCountry == '其他') {
                            ohterPublishCity = form.publishCity;
                        } else {
                            parr.push(form.publishProvince);
                            parr.push(form.publishCity);
                        }
                    }
                }

                return {placeOfPublication: parr}
            },

            /***************************检查登录，打开登录框方法*************************/
            checkLogin() {
                if (Cookies.get("userInfo") && Cookies.get("userInfo") != '') {
                    this.userInfo = JSON.parse(Cookies.get("userInfo"));
                    return true
                } else {
                    this.$store.state.app.showLoginOrRegistter = true;
                    return false;
                }
            },

            /***************************检查是否上传状态*************************/
            checkUploading() {
                //作品文件检查、作品相关权属文件检查、创作声明检查
                var checkFlag = true;
                let worksList = this.worksList; //作品文件
                let enclosureList = this.enclosureList; //作品相关权属文件
                let statementList = this.statementList; //创作声明
                let publishUrlList = this.publishUrlList;

                if (checkFlag && worksList && worksList.length > 0) {
                    for (let i = 0; i < worksList.length; i++) {
                        if (worksList[i].status && worksList[i].status == 'uploading') {
                            checkFlag = false;
                            break;
                        }
                    }
                }


                if (checkFlag && enclosureList && enclosureList.length > 0) {
                    for (let i = 0; i < enclosureList.length; i++) {
                        if (enclosureList[i].status && enclosureList[i].status == 'uploading') {
                            checkFlag = false;
                            break;
                        }
                    }
                }

                if (checkFlag && statementList && statementList.length > 0) {
                    for (let i = 0; i < statementList.length; i++) {
                        if (statementList[i].status && statementList[i].status == 'uploading') {
                            checkFlag = false;
                            break;
                        }
                    }
                }

              if (checkFlag && publishUrlList && publishUrlList.length > 0) {
                for (let i = 0; i < publishUrlList.length; i++) {
                  if (publishUrlList[i].status && publishUrlList[i].status == 'uploading') {
                    checkFlag = false;
                    break;
                  }
                }
              }


                return checkFlag
            }
        },
        watch: {
            "$store.state.app.showPayWay": function () {
                if (this.$store.state.app.showPayWay) {
                    this.userInfo = JSON.parse(Cookies.get("userInfo"));
                    this.flagId = '';
                    this.PayWay = 'PayWay';
                    this.getByPage(this.getObligeeParams.registerId = this.userInfo.id);

                }
            },

        },
    }
</script>

<style lang="less" scoped>
    #copyrightRegistration {
        width: 100%;
        background: #F1F4F8;
    }

    .copyrightRegistration {
        width: 1334px;
        min-height: 2000px;
        background: #FFFFFF;
        box-shadow: 0px 2px 40px 0px rgba(29, 31, 108, 0.04);
        border-radius: 4px;
        margin: 0 auto;
        padding-top: 20px;
        padding-bottom: 60px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;

        /deep/ .ivu-radio {
            line-height: revert;
        }

        /deep/ .ivu-radio-focus {
            box-shadow: none;
        }

        .row_item {
            width: 100%;
            height: 80px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
        }

        .row_item_1 {
            width: 100%;
            height: 80px;
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
        }

        .col_label {
            width: 140px;

            p {
                width: 140px;
                text-align: right;
                font-size: 14px;
                font-weight: 400;
                color: rgba(102, 102, 102, 1);
                line-height: 20px;
            }
        }

        .col_value {
            margin-left: 60px;
            display: flex;
            align-items: center;
        }

        .top20 {
            margin-top: 20px;
        }

        .selectWidth {
            width: 320px;
            height: 38px;
        }

        .radio_group .radio_item_name {
            font-size: 14px;
            color: #666666;
            margin-left: -18px;
            padding-top: 3px;
        }

        .monitor_type .radio_item {
            margin-right: 40px;
        }

        .radio_item.ivu-radio-wrapper-checked .radio_item_name {
            color: #666666;
        }

        /deep/ .radio_item .ivu-radio {
            margin-right: 10px;
        }

        /deep/ .radio_item .ivu-radio-inner {
            width: 12px;
            height: 12px;
            border-radius: 0;
            /*border: 1px solid #B5B5B5;*/
        }

        /deep/ .radio_item .ivu-radio-inner {
            width: 12px;
            height: 12px;
            /*background: url(../../../assets/common/unChecked.png) no-repeat;*/
            border-color: #b5b5b5;
            background-size: cover;
        }

        .radio_item .ivu-radio-checked .ivu-radio-inner {
            border-color: #FFD800;
        }

        /deep/ .radio_item .ivu-radio-inner:after {
            width: 12px;
            height: 12px;
            left: -1px;
            top: -1px;
            /*background: url(../../../assets/common/new_lo_ye.png) no-repeat;*/
            background-color: #ffd800;
            /*background-size: cover;*/
        }

        /deep/ .radio_item .ivu-radio-inner:after {
            width: 12px;
            height: 12px;
            left: -1px;
            top: -1px;
            border-radius: 0;
            background-color: #ffd800;
        }

        /deep/ .ivu-select-single .ivu-select-selection {
            height: 38px;
        }

        /deep/ .ivu-select-selection:hover {
            /*border: 1px solid #ffd800;*/
            border-color: #ffd800;
        }

        /deep/ .ivu-select-selection-focused {
            border-color: #ffd800;
        }

        /deep/ .ivu-select-visible .ivu-select-selection {
            border-color: #ffd800;
            box-shadow: none;
        }

        /deep/ .ivu-input:hover {
            border-color: #ffd800;
        }

        /deep/ .ivu-date-picker-focused input {
            box-shadow: none;
            border-color: #ffd800;
        }

        /deep/ .el-cascader:not(.is-disabled):hover .el-input__inner {
            border-color: #ffd800;
        }

        /deep/ .el-cascader .el-input .el-input__inner:focus {
            border-color: #ffd800;
        }

        /deep/ .el-cascader .el-input.is-focus .el-input__inner {
            border-color: #ffd800;
        }

        /deep/ .row_item .ivu-select-selection .ivu-select-selected-value {
            height: 38px;
            line-height: 38px;
        }

        /deep/ .row_item .ivu-select-selection .ivu-select-placeholder {
            height: 38px;
            line-height: 38px;
            color: #999999;
        }

        .certList_right {
            display: flex;
            flex-direction: column;

            .certList_right_top {
                height: 194px;
                display: flex;
                justify-content: flex-start;

                .showtextDf {
                    margin-left: 20px;

                    div {
                        height: 20px;
                        font-size: 14px;
                        font-weight: 400;
                        color: rgba(153, 153, 153, 1);
                        line-height: 20px;
                        margin-top: 64px;
                        margin-bottom: 10px;
                    }

                    p {
                        font-size: 14px;
                        font-weight: 400;
                        color: rgba(153, 153, 153, 1);
                        line-height: 20px;
                    }
                }
            }
        }

        .show_Picture {
            margin-right: 20px;

            div {
                width: 103px;
                height: 22px;
                font-size: 12px;
                font-weight: 400;
                color: rgba(102, 102, 102, 1);
                line-height: 17px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                margin-top: 5px;
            }

            .showSc {
                position: relative;
                height: 70px;
                width: 103px;
                cursor: pointer;

                &:hover {
                    width: 103px;
                    height: 70px;

                    .showDelete {
                        display: block;
                    }
                }

                .showDelete {
                    width: 103px;
                    height: 70px;
                    background: rgba(0, 0, 0, 0.3);
                    display: none;
                    position: absolute;
                    left: 0;
                    right: 0;
                    top: 0;
                    bottom: 0;
                    margin: auto;
                    text-align: center;
                    overflow: hidden;
                }

                .showshanchu {
                    width: 18px;
                    height: 18px;
                    margin-top: 26px;
                }

                .showCm {
                    width: 84px;
                    height: 25px;
                    background: rgba(0, 0, 0, 1);
                    border-radius: 6px 6px 0px 0px;
                    opacity: 0.6;
                    font-size: 12px;
                    font-weight: 400;
                    color: rgba(255, 255, 255, 1);
                    line-height: 25px;
                    text-align: center;
                    position: absolute;
                    left: 0;
                    top: 0;
                }
            }

            .showSc_autor {
                position: relative;
                min-width: 108px;
                height: 38px;
                cursor: pointer;
                margin-top: 0px;

                &:hover {
                    min-width: 108px;
                    height: 38px;

                    .showshanchu {
                        display: block;
                    }
                }

                .showshanchu {
                    width: 14px;
                    height: 14px;
                    position: absolute;
                    top: 10px;
                    right: 10px;
                    display: none;
                    /*margin-top:26px;*/
                }
            }
        }

        .show_Picture_autor {
            margin: 10px 20px 10px 0;

            div {
                height: 22px;
                font-size: 12px;
                font-weight: 400;
                color: rgba(102, 102, 102, 1);
                line-height: 17px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                margin-top: 5px;
            }

            .showSc_autor {
                position: relative;
                min-width: 108px;
                height: 38px;
                cursor: pointer;
                margin-top: 0px;

                &:hover {
                    min-width: 108px;
                    height: 38px;

                    .showshanchu {
                        display: block;
                    }
                }

                .showshanchu {
                    width: 14px;
                    height: 14px;
                    position: absolute;
                    top: 12px;
                    right: 10px;
                    display: none;
                }
            }

            .autors_class {
                height: 38px;
                background: rgba(247, 181, 0, .1);
                border-radius: 19px;
                border: 1px solid #ffe8aa;
                padding-left: 15px;
                padding-right: 30px;
                padding-top: 10px;
                font-size: 14px;
                font-weight: 400;
                color: #f7b500;
                outline: none;
            }
        }

        .power_des {
            width: 100%;
            height: 68px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            line-height: 68px;
            /*padding-left: 40px;*/
            margin-top: 30px;
            margin-bottom: 24px;

        }

        .publish_status {
            display: flex;
            align-items: center;

            .pulish_status_span {
                margin-left: 20px;
                margin-right: 15px;
            }
        }

        .creatInfo-span {
            margin-left: 30px;
            margin-right: 10px;
            width: 56px;
            font-size: 14px;
            font-weight: 400;
            color: #f7b500;
            text-decoration: underline;
        }

        .declare_sample {
            margin-left: 10px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            cursor: pointer;
        }


        .checkImg {
            width: 12px;
            height: 12px;
            margin-right: 10px;
            /*margin-top: 3px;*/
            display: inline-block;
            border: 1px solid #B5B5B5;
            vertical-align: middle;

            &.active {
                background: #ffd800;
                border: none;
            }
        }

        .owner_checkbox {
            width: 895px;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;

            div {
                margin-right: 40px;
                margin-top: 20px;
                height: 38px;
                background: rgba(255, 255, 255, 1);
                border-radius: 19px;
                border: 1px solid rgba(238, 238, 238, 1);
                cursor: pointer;
            }

            p {
                font-size: 14px;
                font-weight: 400;
                color: rgba(102, 102, 102, 1);
                line-height: 20px;
                padding-left: 27px;
                padding-top: 8px;
                padding-right: 27px;
            }

            .active {
                background: rgba(247, 181, 0, 0.1);
                border-radius: 19px;
                border: 1px solid #ffe8aa;
                font-size: 14px;
                font-weight: 400;
                line-height: 20px;

                p {
                    color: #f7b500;
                }
            }

            img {
                width: 18px;
                height: 19px;
                margin-left: 88%;
                margin-top: -4px;
            }

        }

        .form_input_btn_select {
            height: 17px;
            font-size: 12px;
            font-weight: 400;
            color: #f7b500;
            line-height: 17px;
            text-decoration: underline;
            cursor: pointer;
        }

        /deep/ .ivu-input {
            height: 38px;
        }

        /deep/ .ivu-input-suffix i {
            line-height: 38px;
        }

        input {
            width: 320px;
            height: 38px;
            background: rgba(255, 255, 255, 1);
            border-radius: 4px;
            border: 1px solid #dcdee2;
            outline: none;
            padding-left: 10px;
            color: #515a6e;
        }


        textarea {
            width: 610px;
            height: 162px;
            background: rgba(255, 255, 255, 1);
            border-radius: 4px;
            border: 1px solid rgba(203, 203, 203, 1);
            outline: none;
            padding-left: 10px;
            padding-top: 10px;
            color: #515a6e;
        }

        input:focus,
        input:hover,
        textarea:focus,
        textarea:hover {
            border: 1px solid #ffd800;
        }

        /deep/ input::-ms-input-placeholder {
            color: #ffd800;
        }

        /deep/ input::-webkit-input-placeholder {
            color: #999999;
        }

        /deep/ input::-moz-placeholder {
            color: #999999;
        }
    }

    .atlas_group{
        display:flex;
        justify-content:flex-start;
        flex-wrap: wrap;
    }
</style>
<style lang="less" scoped>
    .btn_blue {
        width: 119px;
        height: 40px;
        background: #ffd800;
        border-radius: 2px;
        font-size: 14px;
        font-weight: 400;
        color: #333;
        line-height: 20px;
        letter-spacing: 1px;
        outline: none;
        border: none;
        cursor: pointer;
    }

    .upload_progress {
        color: #F7B500 !important;
        font-size: 14px;
        text-align: center;
        border: 1px solid #F7B500;
        flex-direction: column;
        display: flex;
        justify-content: center;
        border-radius: 4px;
        cursor: default;


        .upload_progress_desc {
            font-size: 24px;
            font-weight: 500;
            line-height: 33px;
        }

        .upload_progress_shadow {
            position: absolute;
            width: 100%;
            bottom: 0;
            background: rgba(255, 216, 0, 0.3);
            border-radius: 4px;
            transition: all .5s;
        }

    }

    .upload_progress_one {
        width: 138px;
        height: 38px;
        border: 1px solid #F7B500;
        border-radius: 4px;
        margin: 0 2px 8px 0;
        font-size: 14px;
        text-align: center;
        line-height: 38px;
        color: #F7B500;
        position: relative;

        .upload_progress_one_shadow {
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            background: rgba(255, 216, 0, 0.3);
            border-radius: 4px;
            transition: all .5s;
        }
    }

    .copyrightRegistration .show_Picture .showSc.upload_progress {
        cursor: default;
    }

    .declare_upload_success_name {
        display: inline-block;
        max-width: 400px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-left: 20px;

    }
</style>
